<template>
  <div class="main-footer">

    <div class="addr-wrap">

      <div class="bb-txt">Copyright © 2018-2020碳索（杭州）能源环境科技有限公司 版权所有 Powered by EyouCms浙江ICP备19041624号</div>
      <div class="bb-txt">地址:浙江省杭州市西湖区西溪路525号C楼5295室 电话：13023631525</div>
    </div>

    <div style="width: 350px"></div>
    <img src="../../../assets/imgs/erwei-code.png">
  </div>
</template>

<script>
export default {
  name: "footView"
}
</script>

<style lang="less" scoped>


.main-footer {
  width: min-content;
  background-color: #3F4041;
  height: 180px;

  display: flex;
  align-items: center;
  justify-content: center;

  .addr-wrap {
    display: flex;
    flex-direction: column;

    .bb-txt {
      color: white;
      width: 740px;
      font-size: 14px;
      font-weight: 600;
    }

  }

  img {
    width: 100px;
    height: 100px;
  }

}
</style>
